export default "__VITE_ASSET__Bt9V4cjS__"